// /src/app/Components/PrivateRoute/PrivateRoute.jsx

import React, { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import { AuthContext } from '../../Context/auth';

function PrivateRoute({ children }) {
  const { logado } = useContext(AuthContext);

  // Se não estiver logado, redireciona para a página de login
  if (!logado) {
    return <Navigate to="/app" />;
  }

  // Se estiver logado, renderiza o componente filho
  return children;
}

export default PrivateRoute;